import '@babel/polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import {Auth} from './services/Auth';
import store from './store';
// import * as Sentry from "@sentry/vue";

// fontawesome
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import 'vuetify/dist/vuetify.min.css'

import { VTextField } from 'vuetify/lib'

let auth;

(async () => {
  auth = new Auth(store, router);
  await auth.init();

  Vue.config.productionTip = false;
  Vue.component('v-text-field', VTextField)

  // Sentry.init({
  //   Vue,
  //   dsn: "https://48d901c5e62d4d3aa90f89dc886b4f4e@sentry.isedo.pl/12"
  // });

  new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
  }).$mount('#app');
})();

export {auth};
